/**
 * Security step constants
 * Shared between parent and child implementations
 */
export const SECURITY_STEPS = {
  CHECKING_AUTH: "checking-auth",
  AUTH_FAILED: "auth-failed", 
  PROFILE_NEEDED: "profile-needed",
  CHECKING_RESOURCES: "checking-resources",
  NO_ACCESS: "no-access",
  AUTHORIZED: "authorized",
} as const;